// Language Options (Indian Languages)
export const languageOptions = [
  { value: "assamese", label: "Assamese" },
  { value: "bengali", label: "Bengali" },
  { value: "gujarati", label: "Gujarati" },
  { value: "hindi", label: "Hindi" },
  { value: "kannada", label: "Kannada" },
  { value: "kashmiri", label: "Kashmiri" },
  { value: "konkani", label: "Konkani" },
  { value: "malayalam", label: "Malayalam" },
  { value: "manipuri", label: "Manipuri" },
  { value: "marathi", label: "Marathi" },
  { value: "nepali", label: "Nepali" },
  { value: "odia", label: "Odia" },
  { value: "punjabi", label: "Punjabi" },
  { value: "sanskrit", label: "Sanskrit" },
  { value: "santali", label: "Santali" },
  { value: "sindhi", label: "Sindhi" },
  { value: "tamil", label: "Tamil" },
  { value: "telugu", label: "Telugu" },
  { value: "urdu", label: "Urdu" },
  { value: "english", label: "English" },
];
